import { Stack, Text, Title } from '@mantine/core';
import { FormattedMessage } from 'react-intl';

import { freightNoCarriersMessageMessages } from './freight-no-carriers-message-messages';
import { FREIGHT_PROVIDER_ID } from '../../ltl/constants';

type FreightNoCarriersMessageProps = {
  freightProviderId?: number | null;
};

export const FreightNoCarriersMessage = ({ freightProviderId }: FreightNoCarriersMessageProps) => {
  const isWwex = freightProviderId === FREIGHT_PROVIDER_ID.Wwex;

  return (
    <Stack data-testid='freight-no-carriers-message' gap='xs'>
      <Title fw={600} order={4}>
        <FormattedMessage {...freightNoCarriersMessageMessages.title} />
      </Title>
      {isWwex ? (
        <Text c='dimmed'>
          <FormattedMessage
            {...freightNoCarriersMessageMessages.bodyWwex}
            values={{
              contact: (chunks) => <a href='mailto:volume@wwex.com'>{chunks}</a>,
            }}
          />
        </Text>
      ) : (
        <Text c='dimmed'>
          <FormattedMessage {...freightNoCarriersMessageMessages.bodyUnishippers} />
        </Text>
      )}
    </Stack>
  );
};
